import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Card,
  CardContent,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
  useToast,
} from "alm-react-components";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {  useNavigate } from "react-router-dom";
import * as yup from "yup";
import almTimeZone from "../../../assets/alm-timezones.json";
import { ActionType, AppcuesConstant, APPROUTES, constants } from "../../../assets/constants/constants";
import { useLayoutEffect } from "react"; 
import { AppContext } from "../../../context/AppProvider";
import {
  getSllUser,
  updateAvatarUrl,
  updateUserProfile,
} from "../../../services/user";
import Profile from "../../common/Profile";
import PageLoader from "../../common/loader/PageLoader";
import { appcues_event } from "../../../assets/constants/staticContentConstants";
import { putAppCuesData } from "../../../lib/appcues";

const EditProfileFrom = (Props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const [timeZone, setTimeZone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone?Intl.DateTimeFormat().resolvedOptions().timeZone:"UTC+01:00(CET) / UTC+02:00(CEST) Europe/Amsterdam"
  );
  const [timeZoneCode, setTimeZoneCode] = useState<any>("");
  const { toast } = useToast();
  const [userDetails, setUserDetails] = useState<any>({});
  const [showButton, setShowButton] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [userFetched, setUserFetched] = useState(false);
  const [userStatus, setUserStatus] = useState('');
  const [emailId, setEmailId] = useState('');
  
  const isProfilePage = location.pathname === "/profile";
  const schema = yup.object().shape(
    {
      fullName: yup
        .string()
        .required(t("Validations.fullNameRequired"))
        .matches(/^[a-zA-Z0-9.$#*!& ]+$/, t("Validations.fullNameChar"))
        .min(3, t("Validations.minFullName"))
        .max(63, t("Validations.maxFullName")),
      displayName: yup
        .string()
        .nullable()
        .notRequired()
        .when("displayName", {
          is: (value: any) => value?.length,
          then: (rule: any) => rule.min(3, t("Validations.minDisplayName")),
        }),
    },
    [
      // Add Cyclic deps here because when require itself
      ["displayName", "displayName"],
    ]
  );

  const form = useForm<any>({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      fullName: "",
      email: "",
      displayName: "",
      timezone: "",
    },
  });

  useEffect(() => {
    if (state?.user?.email && !userFetched) {
      setSllUser();
    }
  }, [state?.user, userFetched]);

  useEffect(() => {
    setTimeZoneCode(getTimeZoneCode());
  }, [timeZone]);

  useEffect(() => {
    if (userDetails?.location) {
      setTimeZone(userDetails?.location);
    }
  }, [userDetails]);

  const getTimeZoneCode = () => {
    return almTimeZone?.timeZone.filter((res: any) => {
      return res?.zoneId === timeZone;
    })[0]?.timeZoneCode;
  };

  const setSllUser = async () => {
    setLoading(true);
    getSllUser(state?.user?.email)
      .then((res: any) => {
        if (res.status === 200) {
          const sData = {
            fullName: res?.data?.fullName,
            displayName: res?.data?.displayName,
            location: res?.data?.timezone,
          };
          const fullName =   res?.data?.fullName  ?? userDetails?.fullName;
          const email =   res?.data?.email   ?? userDetails?.email;
          const displayName =  res?.data?.displayName  ?? userDetails?.displayName;
          
          const location = res?.data?.timeZone ? res?.data?.location : userDetails?.location;
          if (fullName) form.setValue('fullName', fullName);
          if (email) setEmailId(email)// form.setValue('email', email);
          if (displayName) form.setValue('displayName', displayName);
          if (location) {
            form.setValue("timezone", location);
            dispatch({ type: "SET_CURRENT_USER_TIMEZONE", payload: location });
          }
          setUserStatus(res?.data?.userStatus)
          setUserDetails(sData);
          setUserFetched(true);
          setLoading(false);
        } else {
          setLoading(false);
          dispatch({
            type: ActionType.ERROR,
            payload: {
              type: "UnAuthorizedUser",
              message: t("ErrorType.retryAgain"),
            },
          });
        }
      })
      .catch(() => {
      setLoading(false);
        dispatch({
          type: ActionType.ERROR,
          payload: {
            type: "UnAuthorizedUser",
            message: t("ErrorType.retryAgain"),
          },
        });
      }) 
  };

  async function onhandleSubmit(values: any) {
    const finalValues: any = {
      fullName: values.fullName,
      displayName: values.displayName,
      timezone: timeZoneCode ? timeZoneCode : getTimeZoneCode(),
    };
    
    dispatch({ type: ActionType.SET_LOADING, payload: true });
    const editProfileResponse: any = await updateUserProfile(finalValues);
    const completion_percent=state?.user?.avatarUrl && values.fullName && values.displayName ? true: false;
    dispatch({ type: ActionType.SET_LOADING, payload: false });
    
    if (editProfileResponse?.status == 200) {
       await updateAvatarUrl();
        putAppCuesData({
          eventName:appcues_event.profileCompleted,
          userId: state.user?.email || "",
          name: state?.user?.name,
          profile_completion_percent: completion_percent ? AppcuesConstant.profileCompletePercent: AppcuesConstant.profileNotCompletePercent,});

      dispatch({
        type: ActionType.UPDATE_USER_PROFILE_NAME,
        payload: finalValues,
      });
      toast({
        description: (
          <div
            dangerouslySetInnerHTML={{
              __html: t("EditProfile.profileUpdatedMessage"),
            }}
          />
        ),
        variant: "success",
      });
       
      setTimeout(() => {
        if (Props.newUser) {
          navigate(APPROUTES.startLearning);
        } else if(userStatus === constants.INCOMPLETE) {
          navigate(APPROUTES.home);
        }
      }, 2000);
    } else {
      toast({
        description: `${editProfileResponse?.error?.message}`,
        variant: "error",
      });
    }
  }

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }, []);

const handleInputChange = (e:any) => {
  form.setValue(e.target.name, e.target.value);
  setShowButton(true);
};

  const onValueChange = (value: any) => {
    setTimeZoneCode(value);
    setShowButton(true);
  };
  
  return (
    <div className="w-[100%] lg:w-[800px] mx-auto md:py-14">
      {loading && <PageLoader />}
      <Card className="bg-transparent dark:border-0 rounded-none">
        <CardContent className="gap-6 md:py-0 md:px-8 flex flex-col md:flex-row">
          <div className="flex flex-col items-center gap-6 mb-3 md: mt-12">
            {state?.isAuthenticated && <Profile />}
            <p className="text-center md:w-[186px]"
            dangerouslySetInnerHTML={{__html: t("Common.msgFileUpload"),}}/>
          </div>
          <div className="w-full flex flex-col justify-between p-4 leading-normal">
            <h1 className="scroll-m-20 tracking-tight leading-7 text-2xl md:text-4xl mb-6 md:mb-16 font-barlowLight font-light"
              dangerouslySetInnerHTML={{__html: t("Common.editProfile"),}}/>
            <div className="grid w-full items-center gap-4 mb-6">
              <Form {...form}>
                <form onSubmit={form.handleSubmit(onhandleSubmit)}>
                  <div className="flex flex-col space-y-1.5 text-base pb-4">
                    <FormField
                      control={form.control}
                      name="fullName"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel
                            className="text-base font-opensansMedium tracking-wider"
                            dangerouslySetInnerHTML={{
                              __html: t("Common.fullName"),
                            }}
                          />
                          <FormControl>
                            <Input
                              {...field}
                              placeholder={t("PlaceHolder.enterFullName")}
                              className="h-auto py-4 text-base"
                              aria-labelledby=""
                              maxLength={63}
                              onChange={handleInputChange}
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>

                  <div className="flex flex-col space-y-1.5 text-base pb-4">
                    <FormField
                      control={form.control}
                      name="displayName"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel className="text-base font-opensansMedium tracking-wider"
                            dangerouslySetInnerHTML={{
                              __html: t("Common.displayName"),
                            }}
                          />
                          <FormControl>
                            <Input
                              {...field}
                              placeholder={t("PlaceHolder.enterDisplayName")}
                              className="h-auto py-4 text-base"
                              maxLength={63}
                              onChange={handleInputChange}
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                  <div className="flex flex-col space-y-1.5 text-base pb-4">
                    <FormField
                      control={form.control}
                      name="timezone"
                      render={() => (
                        <FormItem>
                          <FormLabel className="text-base font-opensansMedium tracking-wider"
                          dangerouslySetInnerHTML={{
                            __html: t("Common.timeZone"),
                          }}
                        />
                          <Select
                            onValueChange={onValueChange}
                            value={
                              timeZoneCode
                                ? timeZoneCode
                                : userDetails?.location
                            }
                          >
                            <FormControl>
                              <SelectTrigger className="h-auto py-4 text-base max-sm:grid max-sm:grid-flow-col">
                                <SelectValue placeholder="Select time zone" />
                              </SelectTrigger>
                            </FormControl>
                            <SelectContent>
                              {almTimeZone?.timeZone?.map((res) => {
                                return (
                                  <SelectGroup key={res?.id}>
                                    <SelectItem
                                      key={res?.id}
                                      value={res?.timeZoneCode}
                                    >
                                      {res?.utcOffset} {res?.zoneId}
                                    </SelectItem>
                                  </SelectGroup>
                                );
                              })}
                            </SelectContent>
                          </Select>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                  <div className="flex flex-col space-y-1.5 text-base pb-4">
                    <FormField
                      control={form.control}
                      name="email"
                      disabled
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel className="text-base font-opensansMedium tracking-wider"
                            dangerouslySetInnerHTML={{
                            __html: t("FieldLable.emailNonEditTable"),
                          }}
                        />
                          <FormControl>
                            <Input
                              {...field}
                              placeholder={t("PlaceHolder.enterEmail")}
                              className="h-auto py-4 text-base"
                              aria-labelledby=""
                              maxLength={63}
                              value={emailId}
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                  <div className="flex justify-between grid-4 space-x-3">
                    {!Props.newUser && (
                    <span
                    onClick={()=>navigate(-1)}
                    className="flex w-full h-auto py-3 border rounded-[10px] justify-center cursor-pointer  hover:bg-transparent bg-transparent font-normaltext-lg text-un-none"
                    dangerouslySetInnerHTML={{
                      __html: t("Common.cancel"),
                    }}
                  />
                    )}
                    <Button
                      disabled={isProfilePage ? false : !showButton}
                      className="w-full h-auto py-3 text-base"
                      dangerouslySetInnerHTML={{
                        __html: t("Common.save"),
                      }}
                    />
                  </div>
                </form>
              </Form>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default EditProfileFrom;
